import { useState } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };


const IMG = {
  minty: "/images/characters/minty.webp",
  logo: "/images/logo.webp",
  g1:  "/images/gallery/photo1.webp",
  g2:  "/images/gallery/photo2.webp",
  g3:  "/images/gallery/photo3.webp",
  g4:  "/images/gallery/photo4.webp",
  g5:  "/images/gallery/photo5.webp",
  g6:  "/images/gallery/photo6.webp",
  g7:  "/images/gallery/photo7.webp",
  g8:  "/images/gallery/photo8.webp",
  g9:  "/images/gallery/photo9.webp",
  g10: "/images/gallery/photo10.webp",
  g11: "/images/gallery/photo11.webp",
  g12: "/images/gallery/photo12.webp",
  g13: "/images/gallery/photo13.webp",
  g14: "/images/gallery/photo14.webp",
  g15: "/images/gallery/photo15.webp",
  g16: "/images/gallery/photo16.webp",
  g17: "/images/gallery/photo17.webp",
  g18: "/images/gallery/photo18.webp",
  g19: "/images/gallery/photo19.webp",
  g20: "/images/gallery/photo20.webp",
  g21: "/images/gallery/photo21.webp",
  g22: "/images/gallery/photo22.webp",
  g23: "/images/gallery/photo23.webp",
  g24: "/images/gallery/photo24.webp",
  g25: "/images/gallery/photo25.webp",
  g26: "/images/gallery/photo26.webp",
};

const colors = [C.pink, C.blue, C.yellow, C.mint, C.lilac];
const photos = [
  IMG.g1,  IMG.g2,  IMG.g3,  IMG.g4,  IMG.g5,  IMG.g6,  IMG.g7,
  IMG.g8,  IMG.g9,  IMG.g10, IMG.g11, IMG.g12, IMG.g13, IMG.g14,
  IMG.g15, IMG.g16, IMG.g17, IMG.g18, IMG.g19, IMG.g20, IMG.g21,
  IMG.g22, IMG.g23, IMG.g24, IMG.g25, IMG.g26,
].map((src, i) => ({ src, color: colors[i % colors.length] }));

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Gallery" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Gallery" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

export default function GalleryPage() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes mintyWiggle {
          0%, 100% { transform: translateX(0) rotate(0deg) scaleX(1) scaleY(1); }
          8% { transform: translateX(-5px) rotate(-4deg) scaleX(1.06) scaleY(0.94); }
          16% { transform: translateX(5px) rotate(4deg) scaleX(0.94) scaleY(1.06); }
          24% { transform: translateX(-6px) rotate(-5deg) scaleX(1.07) scaleY(0.93); }
          32% { transform: translateX(6px) rotate(5deg) scaleX(0.93) scaleY(1.07); }
          40% { transform: translateX(-5px) rotate(-4deg) scaleX(1.06) scaleY(0.94); }
          48% { transform: translateX(5px) rotate(4deg) scaleX(0.94) scaleY(1.06); }
          56% { transform: translateX(-4px) rotate(-3deg) scaleX(1.04) scaleY(0.96); }
          64% { transform: translateX(4px) rotate(3deg) scaleX(0.96) scaleY(1.04); }
          72% { transform: translateX(-3px) rotate(-2deg) scaleX(1.03) scaleY(0.97); }
          80% { transform: translateX(3px) rotate(2deg) scaleX(0.97) scaleY(1.03); }
          90% { transform: translateX(-1px) rotate(-1deg) scaleX(1.01) scaleY(0.99); }
        }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .photo-card { transition: transform 0.2s ease, box-shadow 0.2s ease; }
        .photo-card:hover { transform: scale(1.02); box-shadow: 0 6px 20px rgba(0,0,0,0.12) !important; }
      `}</style>

      <Nav />

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, ${C.mintSoft} 100%)`,
        padding: "36px 24px 28px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={28} tag="h1">Gallery</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 15, color: C.ink + "aa",
            lineHeight: 1.6, margin: "8px auto 0", maxWidth: 420,
          }}>
            The Funky Bunch in action! Take a peek at what goes on in our classes.
          </p>
        </div>
      </section>

      {/* Photo grid */}
      <section style={{ padding: "20px 24px 48px" }}>
        <style>{`
          .gallery-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 12px;
            max-width: 900px;
            margin: 0 auto;
          }
          @media (max-width: 640px) {
            .gallery-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; }
          }
        `}</style>
        <div className="gallery-grid">
          {photos.map((p, i) => (
            <div
              key={i}
              className="photo-card"
              onClick={() => setLightbox(i)}
              style={{
                cursor: "pointer",
                borderRadius: 14,
                overflow: "hidden",
                border: `3px solid ${p.color}55`,
                boxShadow: `0 2px 12px ${p.color}22`,
                aspectRatio: "1 / 1",
                background: p.color + "15",
              }}
            >
              <img src={p.src} alt="" style={{
                width: "100%", height: "100%",
                objectFit: "cover", display: "block",
              }} />
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.75)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 200, padding: 24,
            animation: "fadeIn 0.2s ease",
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              maxWidth: 550, width: "100%",
              background: "#fff",
              borderRadius: 20,
              overflow: "hidden",
              border: `4px solid ${photos[lightbox].color}55`,
              animation: "fadeIn 0.3s ease",
              position: "relative",
            }}
          >
            <img src={photos[lightbox].src} alt="" style={{
              width: "100%", display: "block",
            }} />
            {/* Nav arrows */}
            <div style={{
              position: "absolute", top: "50%", left: 10,
              transform: "translateY(-50%)",
              width: 36, height: 36, borderRadius: "50%",
              background: "rgba(255,255,255,0.85)",
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", fontSize: 18, color: C.ink, fontWeight: 700,
            }} onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + photos.length) % photos.length); }}>
              ‹
            </div>
            <div style={{
              position: "absolute", top: "50%", right: 10,
              transform: "translateY(-50%)",
              width: 36, height: 36, borderRadius: "50%",
              background: "rgba(255,255,255,0.85)",
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", fontSize: 18, color: C.ink, fontWeight: 700,
            }} onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % photos.length); }}>
              ›
            </div>
            <div
              onClick={() => setLightbox(null)}
              style={{
                position: "absolute", top: 10, right: 10,
                width: 32, height: 32, borderRadius: "50%",
                background: "rgba(255,255,255,0.85)",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", fontSize: 16, fontWeight: 700, color: C.ink,
              }}
            >×</div>
          </div>
        </div>
      )}

      {/* CTA */}
      <section style={{
        background: `linear-gradient(135deg, ${C.pinkSoft}, ${C.lilacSoft}, ${C.blueSoft})`,
        padding: "48px 24px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22}>Want to join the fun?</RainbowHeading>
          <p style={{ fontFamily: body, fontSize: 14, color: C.ink + "99", margin: "8px 0 24px" }}>
            Book a class and your little one could be dancing with us next Thursday!
          </p>
          <button style={{
            background: C.pink, color: "#fff", border: "none",
            padding: "14px 36px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 16, cursor: "pointer",
          }} onClick={() => { window.location.hash = "classes"; }}>Book a Class</button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
